import React from 'react';

const ArticleSearch = ({onChange}) => {

  return (
    <input
      type="text"
      onChange={onChange}
      placeholder="Search..."
    />
  )
};

export default ArticleSearch;



// WEBPACK FOOTER //
// ./src/components/Dictionary/ArticleSearch.js